export default __webpack_public_path__ + "sidechannel-dark.svg";